angular.module("digitalLeasing.module")
  .component("qva", {
    templateUrl: "ng/components/digitalLeasing/qva/qva.view.html",
    controllerAs: "qvaCtrl",
    bindings: {
      model: "=",
      assurances: "=",
      id: "=",
      checkQva: "=",
      snapshot:'<',
      portalRunned:'<',
      numeroContratto:"<",
      modulo:"<",
      isCruscotto:"<",
      editable:'<',
      contractSelected:'<',
      isPostVendita: "="
    },
    controller: function ($digitalService, $portalService) {
      var self = this;

      self.$digitalService = $digitalService;
      self.portalService = $portalService;

      self.supportModel = {
        checkDownloadsAssurances: false,
        everyQuestionIsAnswered: false
      }

      self.$onInit = function () {
        jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
        self.model = self.model;
        self.assurances = self.assurances;
        self.id = self.id;
        self.checkQva = self.checkQva;
      };


      self.$onChanges = function (changes) {

      };


      self.checkDownload = function(areAllDocDownloaded) {

        if(areAllDocDownloaded) {
         self.supportModel.checkDownloadsAssurances = true;
        }

        self.check();
        
        
      } 

      self.isEveryQuestionAnswered = function(everyQuestionAnswered) {

        
          self.supportModel.everyQuestionIsAnswered = everyQuestionAnswered;
        

        self.check();

      }

      self.check = function () {
        if(self.portalService.isAru()) {
          if( self.supportModel.checkDownloadsAssurances && self.supportModel.everyQuestionIsAnswered) {
            self.checkQva = true;
          }else{
            self.checkQva = false;
          }
        } else {
          if(self.supportModel.everyQuestionIsAnswered) {
            self.checkQva = true;
          }else{
            self.checkQva = false;
          }
        }
       
      }
     
    }
  });